import React, { useEffect, useState } from 'react';
import Alert from './Alert';
import { cn } from '../utils/cn';

/**
 * Toast Component - Feedback
 * Auto-dismissing notification toast
 * 
 * @param {Object} props
 * @param {string} props.variant - Alert variant
 * @param {string} props.message - Toast message
 * @param {number} props.duration - Auto-dismiss duration in ms
 * @param {Function} props.onDismiss - Dismiss handler
 */
const Toast = ({
  variant = 'info',
  message,
  title,
  duration = 5000,
  onDismiss,
  className = '',
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => onDismiss?.(), 300); // Wait for fade out
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onDismiss]);

  if (!isVisible) return null;

  return (
    <div
      className={cn(
        'transform transition-all duration-300 ease-in-out w-full',
        isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0',
        className
      )}
      {...props}
    >
      <Alert variant={variant} title={title} dismissible onDismiss={() => {
        setIsVisible(false);
        setTimeout(() => onDismiss?.(), 300);
      }}>
        {message}
      </Alert>
    </div>
  );
};

export default Toast;
